import React from 'react'

import { SvgProps } from '../types'
import { Icon } from '../Icon'

export const CloseCircle: React.FC<SvgProps> = ({
  fill = 'currentColor',
  ...props
}) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.7998 12C20.7998 7.13989 16.8601 3.2002 12 3.2002C7.13989 3.2002 3.2002 7.13989 3.2002 12C3.2002 16.8601 7.13989 20.7998 12 20.7998V22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22V20.7998C16.8601 20.7998 20.7998 16.8601 20.7998 12Z"
        fill="currentColor"
      />
      <path
        d="M16.5762 7.35547L16.9277 7.71094L12.6738 11.9238L16.9277 16.1377L16.5762 16.4922L16.2236 16.8477L11.9629 12.627L7.70312 16.8477L7.35156 16.4922L7 16.1377L11.2529 11.9238L7 7.71094L7.70312 7L11.9629 11.2197L16.2236 7L16.5762 7.35547Z"
        fill="currentColor"
      />
    </Icon>
  )
}
